module.exports = __webpack_public_path__ + "img/Frente-30-00 off.93b9a91a.png";